import React from 'react';
import Skeleton from 'react-loading-skeleton';

const LoanViewSkeleton: React.FC = () => (
    <section className="loan-details loan-details__skeleton">
        <dl className="loan-details__content">
            <dt className="loan-view-interest__label">
                <Skeleton width={180} height={18} />
            </dt>
            <dd className="loan-view-interest__value">
                <Skeleton width={40} height={18} />
            </dd>
        </dl>
        <dl className="loan-details__content">
            <dt className="loan-view-payment-date__label">
                <Skeleton width={180} height={18} />
            </dt>
            <dd className="loan-view-payment-date__value">
                <Skeleton width={150} height={18} />
            </dd>
        </dl>
        <dl className="loan-details__content">
            <dt className="loan-view-payment-date__label">
                <Skeleton width={180} height={18} />
            </dt>
            <dd className="loan-view-payment-date__value">
                <Skeleton width={105} height={18} />
            </dd>
        </dl>
    </section>
);

export default LoanViewSkeleton;
